'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const clsx = require('clsx');

const mergeClassNames = (classNames, props) => {
  const transformedClassNames = [];
  for (const className of classNames) {
    if (typeof className === "function") {
      transformedClassNames.push(className(props));
    } else {
      transformedClassNames.push(className);
    }
  }
  return clsx.clsx(transformedClassNames);
};

exports.mergeClassNames = mergeClassNames;
//# sourceMappingURL=mergeClassNames.cjs.js.map
